import React, { useEffect, useRef } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import { Formik, Form, Field } from "formik";
import {
  PostMasterCompany,
  UpdateMasterCompany,
} from "../../../Service/_index";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import Button from "@mui/material/Button";
import Styles from "../../../UiComponents/Scss/AddPopup.module.scss";

const AddMasterCompany = (props) => {
  const { selectedData, formType, setOpenDrawer, title, GetActiveData } = props;
  let formRef = useRef();

  const initialValues = {
    masterCompanyName: "",
    gstNumber: "",
    panNumber: "",
    remarks: "",
  };

  useEffect(() => {
    if (formType === "edit" || formType === "view") {
      Object.keys(initialValues).forEach((el) => {
        initialValues[el] = selectedData[el];
      });
    }
    formRef.setFieldValue(initialValues);
  }, []);

  const UserId = sessionStorage.getItem("UserId");

  const onKeyDownHandler = (e, values) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSubmit(e, values, "Save");
    }
  };

  const onSubmit = (e, data, keys) => {
    ["masterCompanyName", "remarks"].forEach(
      (item) => (data[item] = data[item]?.toUpperCase())
    );
    data.updatedAt = new Date();

    if (e.key === "Enter" || keys === "Save") {
      if (formType === "add") {
        data.createdBy = UserId;
      } else if (formType === "edit") {
        data.updatedBy = UserId;
      }
      let SubmitType =
        formType === "edit"
          ? UpdateMasterCompany(selectedData._id, data)
          : PostMasterCompany(data);
      SubmitType.then((res) => {
        if (!res) {
          setOpenDrawer(true);
        } else {
          setOpenDrawer(false);
          GetActiveData();
        }
      }).catch((error) => {
        console.log(error);
      });
    } else if (keys === "Save&Create") {
      PostMasterCompany(data).then((res) => {
        GetActiveData();
        if (res) {
          formRef.resetForm();
        }
      });
    }
  };
  return (
    <>
      <div className="DrawerContainer">
      <Grid container className="DrawerHeader">
        <Grid item xs={6} sm={6}>
          <Typography>{title} Master Company</Typography>
        </Grid>
        <Grid item xs={6} sm={6} className="d-flex justify-content-end">
          <CloseIcon
            onClick={() => setOpenDrawer(false)}
            // sx={{ cursor: "pointer" }}
          />
        </Grid>
      </Grid>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => {
          onSubmit(values);
        }}
        innerRef={(ref) => {
          if (ref) {
            formRef = ref;
          }
        }}
      >
        {({ values }) => (
          <Form onKeyDown={(e) => onKeyDownHandler(e, values)}>
            <div className={Styles.addContent}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  {/* <FloatLabel
                    label="MasterCompany Name"
                    value={values.masterCompanyName}
                  > */}
                   <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      MasterCompany Name
                    </Typography>
                    <Field
                      disabled={formType === "view" ? true : false}
                      name="masterCompanyName"
                      placeHolder="Enter MasterCompany"
                      className="InputFiled"
                      style={{ textTransform: "uppercase" }}
                    />
                  {/* </FloatLabel> */}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {/* <FloatLabel label="GST Number" value={values.gstNumber}> */}
                  <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      GST Number
                    </Typography>
                    <Field
                      disabled={formType === "view" ? true : false}
                      name="gstNumber"
                      placeHolder="Enter GST Number"
                      style={{ textTransform: "uppercase" }}
                      className="InputFiled"
                    />
                  {/* </FloatLabel> */}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {/* <FloatLabel label="Pan Number" value={values.panNumber}> */}
                  <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Pan Number
                    </Typography>
                    <Field
                      disabled={formType === "view" ? true : false}
                      name="panNumber"
                      placeHolder="Enter Pan Number"
                      style={{ textTransform: "uppercase" }}
                      className="InputFiled"
                    />
                  {/* </FloatLabel> */}
                </Grid>
                <Grid item xs={12} sm={12}>
                  {/* <FloatLabel label="Remarks" value={values.remarks}> */}
                  <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Remarks
                    </Typography>
                    <div className="common-field-wrapper">
                    {/* {formType !== "view" && formType !== "edit" &&  <span className="common-placeholder">Write here...</span>} */}
                    <Field
                      disabled={formType === "view" ? true : false}
                      name="remarks"
                      className="InputFileds"
                      placeholder={formType !== "view" && formType !== "edit" ? "Write here..." : ""}
                      // style={{ height: "90px", minHeight: "90px" }}
                      style={{ textTransform: "uppercase" }}
                    />
                    </div>
                  {/* </FloatLabel> */}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{ display: formType === "view" ? "block" : "none" }}
                >
                  {/* <FloatLabel label="Created Date" value={"react"}> */}
                  <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Created Date
                    </Typography>
                    <Field
                      name="remarks"
                      className="InputFiled"
                      disabled={formType === "view" ? true : false}
                      value={moment(selectedData?.createdAt).format("L")}
                    />
                  {/* </FloatLabel> */}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{ display: formType === "view" ? "block" : "none" }}
                >
                  {/* <FloatLabel label="Updated Date" value={"react"}> */}
                  <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Updated Date
                    </Typography>
                    <Field
                      name="remarks"
                      className="InputFiled"
                      disabled={formType === "view" ? true : false}
                      style={{ textTransform: "uppercase" }}
                      value={moment(selectedData?.updatedAt).format("L")}
                    />
                  {/* </FloatLabel> */}
                </Grid>
              </Grid>
            </div>

            <div className="Dialog_Footers">
            <div className="Dialog_Button_Groups">
              <Button
                onClick={() => setOpenDrawer(false)}
                className="Dialog_Cancels"
              >
                Cancel
              </Button>
              <Button
                type="submit"
                onClick={(e) => onSubmit(e, values, "Save")}
                className="Dialog_Saves"
                sx={{ display: formType === "view" ? "none" : "block",
                 }}
              >
                {selectedData?._id ? "Update" : "Save & Exit"}
              </Button>
              </div>
              <Button
              sx={{
                marginLeft: "10px",
               }}
                onClick={(e) => onSubmit(e, values, "Save&Create")}
                className="Dialog_Save_Exits"
              >
                Save & Create new
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
    </>
  );
};

export default AddMasterCompany;
